import { API_URL } from '@/constants/env'

import { SweetspotError } from '@/helpers/error'

import DataLoader from '@/vendor/dataloader'

import type { AwardExistenceCheckResponse } from './types'

/** Maximum number of award IDs to check in a single API request */
const MAX_BATCH_SIZE = 50

const api = {
  checkAwardsExist: async (
    awardIds: string[],
    accessToken: string,
  ): Promise<AwardExistenceCheckResponse> => {
    const res = await fetch(
      `${API_URL}/api/v1/usaspending/awards/check-exist`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ award_ids: awardIds }),
      },
    )

    if (!res.ok) {
      throw new SweetspotError({
        name: 'FETCH_ERROR',
        message: res.statusText,
        cause: {
          status: res.status,
        },
      })
    }

    return (await res.json()) as AwardExistenceCheckResponse
  },
}

const batchAwardExistence = async (
  keys: readonly string[],
  accessToken: string,
): Promise<(boolean | Error)[]> => {
  const uniqueKeys = [...new Set(keys)]
  const response = await api.checkAwardsExist(uniqueKeys, accessToken)

  return keys.map((key) => {
    const result = response.results[key]
    return result === undefined ? false : result
  })
}

export const createAwardExistenceLoader = (accessToken: string) => {
  return new DataLoader<string, boolean>(
    (keys) => batchAwardExistence(keys, accessToken),
    {
      cacheKeyFn: (key) => key,
      maxBatchSize: MAX_BATCH_SIZE,
    },
  )
}
